// Estilo de Filtrar y ordenar + aire inferior de colecciones (solo en paginas con filtros) + extras
(() => {
    const s = document.currentScript;
    if (!s || !s.src) return;
    // k cambia cada hora para que los ajustes nuevos lleguen sin esperar a la cache del navegador
    const ver = (s.src.indexOf('?') > -1 ? '&' : '?') + 'k=' + Math.floor(Date.now() / 3600000);
    function extras() {
        const e = document.createElement('script');
        e.src = s.src.replace('kyra-shipping-bar.js', 'kyra-extras.js') + ver;
        e.defer = true;
        document.head.appendChild(e);
    }
    extras();
    function add() {
        if (document.getElementById('kyra-facets-css')) return;
        if (!document.querySelector('.mobile-facets, #main-collection-filters')) return;
        const l = document.createElement('link');
        l.id = 'kyra-facets-css';
        l.rel = 'stylesheet';
        l.href = s.src.replace('kyra-shipping-bar.js', 'kyra-facets.css') + ver;
        document.head.appendChild(l);
        const st = document.createElement('style');
        st.id = 'kyra-collection-spacing';
        st.textContent = '.product-grid-container .collection{padding-bottom:44px}@media screen and (min-width:990px){.product-grid-container .collection{padding-bottom:64px}}';
        document.head.appendChild(st);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();

(() => {
    // Envio: menos de $500 = $129 / $500 a $748.99 = $99 / desde $749 = GRATIS (igual que Configuracion > Envios)
    const target = 74900; // Meta en centavos ($749 MXN)

    function rateFor(cents) {
        if (cents >= 74900) return 0;
        if (cents >= 50000) return 9900;
        return 12900;
    }

    function formatMoney(cents, withCurrency = true) {
        return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + (withCurrency ? ' MXN' : '');
    }

    function injectStyles() {
        if (document.getElementById('kyra-shipping-info-css')) return;
        const st = document.createElement('style');
        st.id = 'kyra-shipping-info-css';
        st.textContent = '.kyra-pdp-shipping-rates{margin:8px 0 0;font-family:Ambit,Helvetica,Arial,sans-serif;font-size:12.5px;line-height:1.35;color:#49302B;text-align:center}' +
            '.kyra-pdp-shipping-rates b{color:#6D0326}' +
            '.kyra-cart-summary__shipping .kyra-free{color:#6D0326;font-weight:700}';
        document.head.appendChild(st);
    }

    // Linea fija con las tarifas debajo de la barra de envio de la ficha
    function ensureRatesLine() {
        document.querySelectorAll('.kyra-pdp-shipping-progress').forEach(box => {
            if (box.querySelector('.kyra-pdp-shipping-rates')) return;
            const p = document.createElement('p');
            p.className = 'kyra-pdp-shipping-rates';
            p.innerHTML = 'Envío $129 · $99 en compras desde $500 · <b>GRATIS</b> desde $749';
            box.appendChild(p);
            const m = document.createElement('p');
            m.className = 'kyra-pdp-shipping-rates kyra-pdp-msi';
            m.innerHTML = 'Paga con tarjeta: <b>3 meses sin intereses</b> desde $749 · <b>6</b> desde $1,249';
            box.appendChild(m);
        });
    }

    function updateShippingBar(cartTotal) {
        ensureRatesLine();
        // En la ficha de producto la barra ya llega calculada desde el servidor con el precio de la pieza: no se toca (evita parpadeos)
        const fills = [...document.querySelectorAll('.kyra-pdp-shipping-progress__fill')].filter(el => !el.closest('.product__info-wrapper'));
        const msgs = [...document.querySelectorAll('.kyra-pdp-shipping-progress__message')].filter(el => !el.closest('.product__info-wrapper'));

        let progress = (cartTotal * 100) / target;
        if (progress > 100) progress = 100;
        if (progress < 0) progress = 0;

        fills.forEach(fill => fill.style.width = progress + '%');

        msgs.forEach(msg => {
            const existingImg = msg.querySelector('img');
            const truckSrc = existingImg ? existingImg.getAttribute('src') : '';

            const remaining = target - cartTotal;
            if (remaining > 0) {
                msg.innerHTML = `
                    <img class="kyra-pdp-shipping-progress__truck" src="${truckSrc}" alt="" width="26" height="22">
                    <span>Te faltan <strong>${formatMoney(remaining)}</strong> para obtener envío <b>GRATIS</b></span>
                `;
            } else {
                msg.innerHTML = `
                    <img class="kyra-pdp-shipping-progress__truck" src="${truckSrc}" alt="" width="26" height="22">
                    <span>¡Ya tienes <b>ENVÍO GRATIS!</b></span>
                `;
            }
        });
    }

    function fetchAndUpdateCart() {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => updateShippingBar(cart.total_price))
            .catch(err => console.error('Error:', err));
    }

    // Carrito (Corner): agrega la fila "Envio" al resumen y suma el envio al total.
    // assets/kyra-corner-cart.js vuelve a pintar el resumen en cada cambio, por eso se revisa seguido.
    let decorating = false;
    async function decorateCartSummary() {
        const box = document.querySelector('#corner-cowi-cart-summary-items-wrapper .kyra-cart-summary');
        if (!box || box.querySelector('.kyra-cart-summary__shipping') || decorating) return;
        decorating = true;
        try {
            const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
            const current = document.querySelector('#corner-cowi-cart-summary-items-wrapper .kyra-cart-summary');
            if (!current || current.querySelector('.kyra-cart-summary__shipping')) return;
            const total = cart.total_price || 0;
            const rate = rateFor(total);
            const row = document.createElement('div');
            row.className = 'kyra-cart-summary__row kyra-cart-summary__shipping';
            row.innerHTML = '<span>Envío (2-3 días hábiles)</span><span>' + (rate ? formatMoney(rate, false) : '<span class="kyra-free">GRATIS</span>') + '</span>';
            const totalRow = current.querySelector('.kyra-cart-summary__row--total');
            if (totalRow) {
                current.insertBefore(row, totalRow);
                const cells = totalRow.querySelectorAll(':scope > span');
                if (cells.length === 2) {
                    cells[0].textContent = 'Total con envío';
                    cells[1].textContent = formatMoney(total + rate);
                }
            } else {
                current.appendChild(row);
            }
        } catch (err) {
            console.error('[Kyra envio] No se pudo calcular el envío:', err);
        } finally {
            decorating = false;
        }
    }

    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
        const response = await originalFetch.apply(this, args);
        if (args[0] && typeof args[0] === 'string' && args[0].includes('/cart/')) {
            setTimeout(fetchAndUpdateCart, 400);
        }
        return response;
    };

    function start() {
        injectStyles();
        fetchAndUpdateCart();
        window.setInterval(decorateCartSummary, 600);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();

// Precio sin ".00" ni espacio tras el $ (precio de la ficha y rango de precio de los filtros)
(() => {
    const re = /\$\s*([\d,]+)\.00(?!\d)/g;
    const re2 = /\$\s+(?=\d)/g;
    let queued = false;
    function fix() {
        queued = false;
        document.querySelectorAll('.price-item, .mobile-facets__info, .facets__price, .facets__display').forEach(el => {
            if (el.textContent.indexOf('$') === -1) return;
            const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            let nd;
            while ((nd = w.nextNode())) {
                const v = nd.nodeValue;
                if (v.indexOf('$') === -1) continue;
                const n = v.replace(re, '$$$1').replace(re2, '$');
                if (n !== v) nd.nodeValue = n;
            }
        });
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(fix); } }
    function init() {
        fix();
        new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
